/* link.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./link.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { N800 } from '@atlaskit/theme/colors';
const linkStyles = null;

/**
 * __Progress tracker link__
 */
const Link = ({
  href,
  onClick,
  label,
  testId
}) => /*#__PURE__*/React.createElement("a", {
  href: href,
  onClick: onClick,
  "data-testid": testId,
  className: ax(["_syaz1fxt _80omtlke"])
}, label);
export default Link;